import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getFullCompatibility, { FullCompatibility } from "../getFullCompatibility";

const useGetFullCompatibility = (gameID?: string, autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<FullCompatibility[]>([]);

  const send = useCallback(async () => {
    if (gameID == null) return;
    setLoading();
    try {
      const compatibility = await getFullCompatibility(gameID);
      setSuccess(compatibility);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [gameID, setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [gameID, autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetFullCompatibility;
